import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

export default function useVerifyResetPasswordToken(queryParams) {
  return useQuery(['reset-Password', queryParams], (_, params) =>
    client('account/passwordReset', { params }).then((res) => res)
  );
}
